'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _isChildFocus = require('../../utils/is-child-focus');

var _isChildFocus2 = _interopRequireDefault(_isChildFocus);

require('./dialog-wrapper.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANIMATION = {
  OPEN: 'open',
  CLOSE: 'close'
};

var DialogWrapper = function (_React$Component) {
  _inherits(DialogWrapper, _React$Component);

  function DialogWrapper(props) {
    _classCallCheck(this, DialogWrapper);

    var _this = _possibleConstructorReturn(this, (DialogWrapper.__proto__ || Object.getPrototypeOf(DialogWrapper)).call(this, props));

    _this.state = {
      animation: ''
    };
    return _this;
  }

  _createClass(DialogWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ animation: ANIMATION.OPEN }); // eslint-disable-line

      if (this.props.forwardedRef && !(0, _isChildFocus2.default)(this.props.forwardedRef.current)) {
        // TODO
        this.props.forwardedRef.current.focus();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.triggerClose !== this.props.triggerClose) {
        this.closeHandler();
      }
    }
  }, {
    key: 'keypressHandler',
    value: function keypressHandler(event) {
      if (event.keyCode !== 27) {
        return;
      }

      event.stopPropagation(); // Prevent closing dialog in dialog.
      this.closeHandler();
    }
  }, {
    key: 'clickHandler',
    value: function clickHandler(event) {
      event.stopPropagation();

      if (event.currentTarget !== event.target) {
        return;
      }

      this.closeHandler();
    }
  }, {
    key: 'closeHandler',
    value: function closeHandler() {
      var _props = this.props,
          disableClose = _props.disableClose,
          onCloseHandler = _props.onCloseHandler;

      if (disableClose) {
        return;
      }

      if (onCloseHandler) {
        this.setState({ animation: ANIMATION.CLOSE }, function () {
          setTimeout(function () {
            return onCloseHandler();
          }, 300); // TODO change onCloseHandler to something else
        });
      } else {
        console.warn('Dialog component must have onCloseHandler property to work correctly');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          renderCustomHeader = _props2.renderCustomHeader;
      var animation = this.state.animation;

      var dialogWrapperClasses = (0, _classnames2.default)('dialog-wrapper', animation && 'dialog-wrapper--animation-' + animation);

      return _reactDom2.default.createPortal(_react2.default.createElement(
        'div',
        {
          className: dialogWrapperClasses,
          onKeyDown: this.keypressHandler.bind(this),
          onClick: this.clickHandler.bind(this),
          tabIndex: '0',
          ref: this.props.forwardedRef
        },
        _react2.default.createElement(
          'div',
          { className: className },
          renderCustomHeader(),
          children
        )
      ), document.body);
    }
  }]);

  return DialogWrapper;
}(_react2.default.Component);

DialogWrapper.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  disableClose: _propTypes2.default.bool,
  onCloseHandler: _propTypes2.default.func,
  renderCustomHeader: _propTypes2.default.func,
  triggerClose: _propTypes2.default.bool,
  forwardedRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object])
};

exports.default = _react2.default.forwardRef(function (props, ref) {
  return _react2.default.createElement(DialogWrapper, _extends({}, props, { forwardedRef: ref }));
});